import { useEffect, useState } from "react";
import GoalCelebration from "../components/GoalCelebration";

/**
 * Dev-only preview for the GoalCelebration component.
 * Visit /goal-preview to visually inspect / screenshot the
 * celebration animation without needing a live goal event.
 */
export default function GoalPreviewPage() {
  const [trigger, setTrigger] = useState(null);

  useEffect(() => {
    // Auto-fire once on mount so screenshot tooling captures the
    // celebration without needing a click.
    setTrigger(`preview-${Date.now()}`);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
      <button
        type="button"
        onClick={() => setTrigger(`preview-${Date.now()}`)}
        className="px-6 py-3 rounded-md bg-emerald-600 text-white font-semibold"
        data-testid="goal-preview-fire-btn"
      >
        Fire Goal Celebration
      </button>

      <GoalCelebration
        trigger={trigger}
        side="home"
        scorer="Erling Haaland"
        teamName="Manchester City"
        teamColor="#6CABDD"
        minute={67}
        score={{ home: 3, away: 2 }}
        soundEnabled={false}
        onDone={() => setTrigger(null)}
      />
    </div>
  );
}
